interface FooterProps {
  locale: string;
  translations?: {
    common?: {
      policies?: string;
    };
  };
}

const Footer = ({ locale, translations }: FooterProps) => {
  return (
    <footer className="relative mt-auto border-t border-n-6/20">
      <div className="container">
        <div className="flex flex-col items-center justify-center gap-0.5 py-3 text-center text-xs text-n-4 sm:flex-row sm:gap-2">
          {locale === 'zh' ? (
            <>
              <span>©2024-2025 群计科技（北京）有限公司</span>
              <span className="hidden opacity-70 sm:block">•</span>
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener"
                className="transition-colors hover:text-n-2 hover:underline"
              >
                京ICP备2024100689号
              </a>
              <span className="hidden opacity-70 sm:block">•</span>
            </>
          ) : (
            <>
              <span>©2024-2025 CrowdComputed</span>
              <span className="hidden opacity-70 sm:block">•</span>
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener"
                className="transition-colors hover:text-n-2 hover:underline"
              >
                京ICP备2024100689号
              </a>
              <span className="hidden opacity-70 sm:block">•</span>
            </>
          )}

          <a
            href="https://faq.crowdcomputed.com/terms-and-policies"
            target="_blank"
            rel="noopener"
            className="transition-colors hover:text-n-2 hover:underline"
          >
            {translations?.common?.policies}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
